import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';


const getFallbackLanguage = () => {
  const userSelectedLanguage = localStorage.getItem('selectedLanguage');
  return userSelectedLanguage || 'en';
};

i18n.use(initReactI18next).init({
  fallbackLng:  getFallbackLanguage(),
  // UserInterfaceLanguage:''
  //lng: 'cn',
  resources: {   
    en: {
      translations: require('./locales/en/translations.json')
    },
    zh: {
      translations: require('./locales/cn/translations.json')
    },
    es: {
      translations: require('./locales/es/translations.json')
    },
    de: {
      translations: require('./locales/de/translations.json')
    },
    fr: {
      translations: require('./locales/fr/translations.json')
    },
    hu: {
      translations: require('./locales/hu/translations.json')
    },
    it: {
      translations: require('./locales/it/translations.json')
    },
    nl: {
      translations: require('./locales/nl/translations.json')
    },
    nn: {
      translations: require('./locales/no/translations.json')
    },
    pt: {
      translations: require('./locales/pt/translations.json')
    },
    ro: {
      translations: require('./locales/ro/translations.json')
    },
    ru: {
      translations: require('./locales/ru/translations.json')
    },
    sv: {
      translations: require('./locales/se/translations.json')
    },
    th: {
      translations: require('./locales/th/translations.json')
    },
    tr: {
      translations: require('./locales/tr/translations.json')
    },
    us: {
      translations: require('./locales/us/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en','zh', 'es', 'de','fr','hu','it','nl','nn','pt','ro','ru','sv','th','tr','us'];

export default i18n;